import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import { Preferences } from "@capacitor/preferences";

import logo from "../assets/logo.png";
import bg from "../assets/bg-temple.png";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    document.getElementById("email")?.focus();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { data } = await API.post("/users/login", {
        email,
        password,
      });

      localStorage.setItem("token", data.token);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("user", JSON.stringify(data.user));

      await Preferences.set({
         key: "token",
         value: data.token,
      });

      await Preferences.set({
         key: "refreshToken",
         value: data.refreshToken,
      });

      API.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
      window.location.href = "/";
    } catch (err) {
      setError(
        err.response?.data?.message ||
        "Email ou mot de passe incorrect"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.overlay} />

      <form onSubmit={handleLogin} style={styles.card}>
        <img src={logo} alt="logo" style={styles.logo} />

        <h2 style={styles.title}>CONNEXION</h2>
        <p style={styles.subtitle}>Accède à ton espace sécurisé</p>

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.inputWrapper}>
          <span style={styles.icon}>✉️</span>
          <input
            id="email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.inputWrapper}>
          <span style={styles.icon}>🔒</span>
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.options}>
         <span
  style={styles.forgot}
  onClick={async () => {
    try {
      if (!email) {
        setError("Entre ton email avant");
        return;
      }

      setError("");

      const response = await fetch(
        "https://api.joss-serveur.duckdns.org/auth/forgot-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        }
      );

      const data = await response.json();

      setError(
        data.message ||
        "Si un compte existe, un email a été envoyé."
      );

    } catch (err) {
      console.error(err);

      setError(
        err.message || "Erreur serveur"
      );
    }
  }}
>
  Mot de passe oublié ?
</span>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={loading ? styles.buttonDisabled : styles.button}
        >
          {loading ? "Connexion..." : "SE CONNECTER"}
        </button>
      </form>
    </div>
  );
}

export default Login;

// ===============================
// 🎨 STYLES FINAL CLEAN
// ===============================
const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    position: "relative",
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background: `
      linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.75))
    `,
  },

  card: {
    position: "relative",
    zIndex: 2,
    transform: "translateY(-70px)",

    width: "100%",
    maxWidth: 320,
    padding: 24,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    gap: 14,

    background: "rgba(0,0,0,0.55)",
    border: "1px solid rgba(212,175,55,0.25)",

    boxShadow: `
      0 20px 60px rgba(0,0,0,0.9),
      0 0 30px rgba(212,175,55,0.08),
      inset 0 0 10px rgba(212,175,55,0.05)
    `,
  },

  logo: {
    width: 80,
    height: 80,
    margin: "0 auto",
    filter: "drop-shadow(0 0 12px rgba(212,175,55,0.4))",
  },

  title: {
    textAlign: "center",
    color: "#D4AF37",
    letterSpacing: 6,
    fontSize: 20,
    fontWeight: "700",
  },

  subtitle: {
    textAlign: "center",
    color: "rgba(255,255,255,0.7)",
    fontSize: 13,
  },

  error: {
    background: "#7f1d1d",
    color: "#fecaca",
    padding: 10,
    borderRadius: 8,
    fontSize: 12,
    textAlign: "center",
  },

  inputWrapper: {
    display: "flex",
    alignItems: "center",
    borderRadius: 14,
    paddingLeft: 12,
    background: "rgba(0,0,0,0.7)",
    border: "1px solid rgba(212,175,55,0.25)",
  },

  icon: {
    color: "#D4AF37",
    marginRight: 10,
  },

  input: {
    flex: 1,
    padding: 14,
    border: "none",
    outline: "none",
    background: "transparent",
    color: "white",
  },

  options: {
    display: "flex",
    justifyContent: "flex-end",
  },

  forgot: {
    fontSize: 12,
    color: "#D4AF37",
    cursor: "pointer",
  },

  button: {
    marginTop: 10,
    padding: 14,
    borderRadius: 14,
    border: "none",
    background: "linear-gradient(135deg, #D4AF37, #F1D77A)",
    color: "#000",
    fontWeight: "700",
    letterSpacing: 1,
    boxShadow: "0 8px 20px rgba(212,175,55,0.3)",
  },

  buttonDisabled: {
    marginTop: 10,
    padding: 14,
    borderRadius: 14,
    border: "none",
    background: "#334155",
    color: "#94a3b8",
  },
};